import React from "react";
import spinner from "./spinner_color.gif";

export default function Loading() {
  return <img alt="loading..." src={spinner} width="100" height="100" />;
}
